var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Details(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-_details",
    "data-name": "icon-24- details",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M8.76,20H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H14a2,2,0,0,1,2,2V12.76a2.98,2.98,0,0,1-.88,2.12l-4.24,4.24A2.981,2.981,0,0,1,8.76,20ZM2,2V18H8V13a1,1,0,0,1,1-1h5V2Zm6.5,8h-4A.5.5,0,0,1,4,9.5v-1A.5.5,0,0,1,4.5,8h4a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,8.5,10Zm3-4h-7A.5.5,0,0,1,4,5.5v-1A.5.5,0,0,1,4.5,4h7a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,11.5,6Z",
    transform: "translate(4 2)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Details);
export default __webpack_public_path__ + "static/media/icon-24- details.263d7574888509f1a18b1f07989abca4.svg";
export { ForwardRef as ReactComponent };